import { registerStore } from 'utils/registerStore';

import { DashboardLayout } from 'presenters/Dashboard/DashboardLayout';
import LessonReportTemplateAddStore from './LessonReportTemplateAddStore';
import LessonReportTemplateAddContainer from './LessonReportTemplateAddContainer';

// step 1 store 생성-등록, root가 필요한 경우 import 해서 사용
registerStore('LessonReportTemplateAddStore', new LessonReportTemplateAddStore());

// step 2 props type 선언

// step 3 page component 선언
function StudentAddEdit() {
  // step 4 root store중 필요한 것 작동시키기 - 생략

  // step 6 방금 만든 페이지용 스토어에 필요한 정보 추가 전달

  // 정확한 id는 searchParam보다는 param을 사용하도록 하자

  return (
    <DashboardLayout>
      <LessonReportTemplateAddContainer />
    </DashboardLayout>
  );
}
export default StudentAddEdit;
